import { IMask } from 'react-imask';

/**
 * Matches the 'NATIONAL' format from libphonenumber-js
 */
export const PHONE_MASK = '(000) 000-0000';
export const ZIP_CODE_MASK = '00000-0000';
/** Validates an either 5 or 9 digit zip code without separators */
export const ZIP_CODE_REGEX = /^\d{5}(\d{4})?$/;

export const CURRENCY_MASK = IMask.createMask({
  mask: '$num',
  blocks: {
    num: {
      mask: Number,
      scale: 2,
      signed: false,
      thousandsSeparator: ',',
      padFractionalZeros: true,
      normalizeZeros: true,
      radix: '.',
      mapToRadix: ['.'],
    },
  },
});

export const TEXT_AREA_MAX_LENGTH_510 = 510;

export function getMaxDocumentsPerIncome(isBaseApplicationChangesEnabled: boolean) {
  return isBaseApplicationChangesEnabled ? 15 : 5;
}

export const MAX_DOG_BREED_LENGTH = 100;
export const MAX_DOG_WEIGHT_LBS_LENGTH = 3;
export const MAX_DOGS = 20;
export const MAX_PERSONAL_REFERENCES = 10;
export const LARGE_DOG_MIN_WEIGHT_LBS = 40;
export const MAX_VEHICLE_FIELD_LENGTH = 100;
export const MAX_VEHICLES = 20;
export const MAX_OCCUPANT_FULL_NAME_LENGTH = 200;
